import pic1 from '../pictures/records/badDesignSolutions/picture1.jpeg';

const data = {
  title: 'Bad design solutions in games ',
  description:
    "Gran Turismo 7 locks the user interface while it saves your car's settings. ",
  infoLink: '/blog/bad-design-solutions',
  meta: {
    title: 'Bad design solutions in games',
    content: "Gran Turismo 7 locks the user interface while it saves your car's settings. ",
  },
  content: [
    {
      type: 'picture',
      content: pic1,
    },
    {
      type: 'text',
      content:
        "Gran Turismo 7 locks the user interface while it saves your car's settings. ",
    },
    {
      type: 'text',
      content:
        'In Cyberpunk 2077 you can’t save the game progress manually while your character is getting out of the car. ',
    },
    {
      type: 'text',
      content:
        "Both games can make it in a background, but don't. It's terrible. ",
    },
  ],
};

export default data;
